import * as actionTypes from 'containers/Campaigns/action-types';
import moment from 'moment';
import { PERIOD_DATE_SET } from 'containers/AccessControl/actionTypes';
import { CAMPAIGNS_TYPE } from 'utils/types';
import { CampaignColumnsKeys, CampaignColumnsKeysType } from 'utils/campaigns';

type StateType = {
  readonly archivedColumns: Array<CampaignColumnsKeysType>;
  readonly campaignsColumns: Array<CampaignColumnsKeysType>;
  readonly currentTab: string;
  readonly endWeek: string;
  readonly errorMessage: string;
  readonly selectedCampaign: string;
};

const initialState: StateType = {
  archivedColumns: CampaignColumnsKeys,
  campaignsColumns: CampaignColumnsKeys,
  currentTab: CAMPAIGNS_TYPE,
  endWeek: moment().format('YYYY-MM-DD'),
  errorMessage: null,
  selectedCampaign: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case PERIOD_DATE_SET:
      // When spins/nielsen dates are setted, update filter endWeek
      return {
        ...state,
        endWeek: action.payload.spins ? action.payload.spins : action.payload.nielsen
      };
    case actionTypes.ARCHIVED_COLUMNS_SET:
      return {
        ...state,
        archivedColumns: [...action.payload]
      };
    case actionTypes.ERROR_MESSAGE_SET:
      return {
        ...state,
        errorMessage: action.payload
      };
    case actionTypes.CAMPAIGN_COLUMNS_SET:
      return {
        ...state,
        campaignsColumns: [...action.payload]
      };
    case actionTypes.CAMPAIGN_SELECT:
      return {
        ...state,
        selectedCampaign: action.payload
      };
    case actionTypes.TAB_SELECT:
      return {
        ...state,
        currentTab: action.payload
      };
    case actionTypes.VIEW_CAMPAIGN:
      return {
        ...state,
        campaignId: action.payload,
        show: true
      };
    case actionTypes.SHOW_SET:
      return {
        ...state,
        show: action.payload
      };
    case actionTypes.CAMPAIGN_SET:
      return {
        ...state,
        details: {
          name: action.payload.name,
          storeGroupName: action.payload.storeGroupName,
          itemGroupName: action.payload.itemGroupName,
          objective: action.payload.objective,
          startDate: action.payload.startDate,
          endDate: action.payload.endDate !== null ? action.payload.endDate : '',
          notes: action.payload.notes !== null ? action.payload.notes : ''
        },
        selection: {
          applied: {
            accounts: action.payload.storeFilters.accounts,
            items: action.payload.itemFilters.items,
            states: action.payload.storeFilters.states,
            stores: action.payload.storeFilters.stores
          },
          transient: {
            accounts: action.payload.storeFilters.accounts,
            items: action.payload.itemFilters.items,
            states: action.payload.storeFilters.states,
            stores: action.payload.storeFilters.stores
          }
        }
      };
    default:
      return state;
  }
};

export default reducer;
